import React from "react";
import InventoryBreadCrumbs from "../../Components/Inventory/InventoryBreadCrumbs";
import InventoryListings from "../../Components/Inventory/InventoryListings";

export default function InventoryListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <InventoryBreadCrumbs />
        <InventoryListings />
      </div>
    </React.Fragment>
  );
}
